import { render, staticRenderFns } from "./BindVd.vue?vue&type=template&id=0be19daa&scoped=true"
import script from "./BindVd.vue?vue&type=script&lang=ts"
export * from "./BindVd.vue?vue&type=script&lang=ts"
import style0 from "./BindVd.vue?vue&type=style&index=0&id=0be19daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be19daa",
  null
  
)

export default component.exports